"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePaymentMethodBodyToJSON = exports.UpdatePaymentMethodBodyFromJSONTyped = exports.UpdatePaymentMethodBodyFromJSON = void 0;
function UpdatePaymentMethodBodyFromJSON(json) {
    return UpdatePaymentMethodBodyFromJSONTyped(json, false);
}
exports.UpdatePaymentMethodBodyFromJSON = UpdatePaymentMethodBodyFromJSON;
function UpdatePaymentMethodBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'expMonth': json['expMonth'],
        'expYear': json['expYear'],
    };
}
exports.UpdatePaymentMethodBodyFromJSONTyped = UpdatePaymentMethodBodyFromJSONTyped;
function UpdatePaymentMethodBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'expMonth': value.expMonth,
        'expYear': value.expYear,
    };
}
exports.UpdatePaymentMethodBodyToJSON = UpdatePaymentMethodBodyToJSON;
